import {defaultSearchFilter} from "../../utils/constants";
import {IconButton, Paper, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import EditIcon from "@material-ui/icons/Edit";
import DeleteFaqButton from "../../components/Button/DeleteFaqButton";
import React from "react";
import {FileCopyOutlined} from "@material-ui/icons";
import {AnswerPreview} from "./AnswerPreview";
import VmtLabels from "./Detail/VmtLabels";


export const _onDelete = async (detailedFaq, setNavigationStatus, fetchFaqs, openAlert, apiRequest) => {

  apiRequest.delete('/assistant/delete', {"data": {"doc_id": detailedFaq._id}})
    .then(() => {
      fetchFaqs();
      openAlert("success", "Domanda cancellata con successo")
    }).catch((err) => {
    console.log(err)
    openAlert("error", "Errore imprevisto")
  })


}

export const showFaq = (faq, navigationStatus, selectedSearchTab = defaultSearchFilter, faqSelection,
                        vmtSelection, setScrollToObject, setNavigationStatus, setEditableFaq, toggleNewFaqDialog,
                        fetchFaqs, isAdmin, isFromKerakoll = true, classes, openAlert,apiRequest) => {

  if (navigationStatus === 'faq_detail' || selectedSearchTab === defaultSearchFilter || faq._source.vertical === selectedSearchTab) {
    const gridWidth = isAdmin ? 11 : 12
    return (
      <Paper className={classes.mainPaper} key={faq._id + faq._source.risposta.substring(0, 10)}>
        <Grid container>
          {isAdmin &&
          <Grid item xs={12}>
            {faq._id}
            <IconButton onClick={() => {
              navigator.clipboard.writeText(faq._id).then(
                openAlert("success", "Codice domanda copiato")
              )
            }}>
              <FileCopyOutlined/>
            </IconButton>
          </Grid>
          }
          <Grid item xs={gridWidth}
          >
            <Typography variant='subtitle2'
                        onClick={() => {
                          faqSelection(faq);
                          setNavigationStatus(navigationStatus);
                        }}
            >
              {faq._source.domanda}
            </Typography>
            <VmtLabels
              vertical={faq._source.vertical}
              macrotema={faq._source.macrotema}
              tema={faq._source.tema}
              setScrollToObject={setScrollToObject}
              vmtSelection={vmtSelection}
              setNavigationStatus={setNavigationStatus}
            />
            <AnswerPreview text={faq._source.risposta}
                           setNavigationStatus={setNavigationStatus}
                           navigationStatus={navigationStatus}
                           faqSelection={faqSelection}
                           faq={faq}
            />
            <Typography align="right">
              <Link className={classes.link} onClick={() => {
                faqSelection(faq);
                setNavigationStatus(navigationStatus);
              }}>
                Vedi tutto...
              </Link>
            </Typography>
          </Grid>
          {isAdmin &&
          <Grid item xs={1}>
            <IconButton
              className={classes.button}
              onClick={() => {
                setEditableFaq(faq);
                toggleNewFaqDialog();
              }}
              color="primary"
            >
              <EditIcon/>
            </IconButton>
            <DeleteFaqButton onDelete={() => _onDelete(faq, setNavigationStatus, fetchFaqs, openAlert, apiRequest)}/>
          </Grid>
          }
        </Grid>
      </Paper>

    )
  }

}